import { render, staticRenderFns } from "./stockFlowTransferDetail.vue?vue&type=template&id=e5974268&scoped=true"
import script from "./stockFlowTransferDetail.vue?vue&type=script&lang=js"
export * from "./stockFlowTransferDetail.vue?vue&type=script&lang=js"
import style0 from "./stockFlowTransferDetail.vue?vue&type=style&index=0&id=e5974268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5974268",
  null
  
)

export default component.exports